module.exports = __webpack_public_path__ + "img/logo.7313f7bb.png";